import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, ManageServiceBO, saveServiceBO } from '../manage-service.modal';
import { ManageService } from '../manage-service.service';
import { ServiceDataservice } from './servicedateservice';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.scss']
})

export class ServiceComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  saveServiceInfo: saveServiceBO = new saveServiceBO();
  MSFilterBo: ManageServiceBO = new ManageServiceBO();
  fp:functionpermission=new functionpermission()
  isSaveorUpdateBoolean:boolean=false;
  @ViewChild('gridService') public gridService: GridComponent;

  public GridList: Observable<DataStateChangeEventArgs>;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  ServiceGroupList: any = [];
  ServiceTypeList: any = [];
  TempServiceTypeList :any=[];
  constructor(public DateService: ServiceDataservice,
    public Msservice: ManageService,
    public global: GlobalComponent, public toasterservice: ToastrService) {
    this.GridList = DateService;
  }

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.MSFilterBo.field = "serviceName";
    this.MSFilterBo.orderColumn = "serviceName";
    this.getServiceFilter();
    this.GetServiceGroupDropdown();
    this.getServiceType();
this.getpermission()
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Manage Services");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.Msservice.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  // ................................................dataChangeTax..............................................
  public dataChangeService(S): void {
    let val = (S.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((S.sorted || []).length) {
        this.MSFilterBo.orderColumn = S.sorted[0].name;
        this.MSFilterBo.orderType = S.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && S.action.action != "clearFilter") {

      this.MSFilterBo.value = S.action.currentFilterObject.value;
      this.MSFilterBo.field = S.action.currentFilterObject.field;
      this.MSFilterBo.matchCase = S.action.currentFilterObject.matchCase;
      this.MSFilterBo.operator = S.action.currentFilterObject.operator;
      if (this.MSFilterBo.type == "number" || this.MSFilterBo.field == "ratio") {
        this.MSFilterBo.type = "decimal";
        if(this.MSFilterBo.value == null || this.MSFilterBo.value == undefined || this.MSFilterBo.value == ''){
          this.MSFilterBo.value = "0";
        }else{
          this.MSFilterBo.value = S.action.currentFilterObject.value.toString();
          this.MSFilterBo.field = S.action.currentFilterObject.field;
        }
      }
    }
    else {
      if (val == "filtering" && S.action.action == "clearFilter") {
        this.MSFilterBo.field = "serviceName";
        this.MSFilterBo.matchCase = false;
        this.MSFilterBo.operator = "contains";
        this.MSFilterBo.value = "";
        this.MSFilterBo.type = "string";
      }
    }
    this.getServiceFilter();
    if (val == "paging" && S.action.name == "actionBegin") {

    }
  }
  //.........................................onActionTAx.....................................................
  public onActionService(S) {
    this.MSFilterBo.currentpageno = this.gridService.pagerModule.pagerObj.currentPage;
    this.MSFilterBo.pageitem = this.gridService.pagerModule.pagerObj.pageSize;
    if (S.name == "actionBegin" && S.requestType == "filterbeforeopen") {
      this.MSFilterBo.type = S.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveServiceBO) {
    this.saveServiceInfo = JSON.parse(JSON.stringify(saveBos));
    this.ServiceTypeRestriction(this.saveServiceInfo?.serviceGroupId);
  }
  //............................................Refresh...................................................
  Refresh() {
    this.saveServiceInfo = new saveServiceBO();
    this.getServiceFilter();
  }

  //.........................................getServiceFilter.............................................
  getServiceFilter() {
    this.DateService.execute(this.MSFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridService.height = '500';
      }
      else {
        this.gridService.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateServiceGroup.............................................
  SaveOrUpdateServiceGroup() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveServiceBO = JSON.parse(JSON.stringify(this.saveServiceInfo));
    savepayload.id = this.saveServiceInfo.id;
    savepayload.ratio =
      (this.saveServiceInfo.ratio != null && this.saveServiceInfo.ratio != undefined && this.saveServiceInfo.ratio != 0)
        ? parseInt(this.saveServiceInfo.ratio.toString()) : 0;
    this.Msservice.saveServices(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (this.saveServiceInfo.id == '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Service saved successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);

      }
      else if (this.saveServiceInfo.id != '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Service updated successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      }
      document.getElementById('openServiceModal').click();
      this.saveServiceInfo = new saveServiceBO();
      this.getServiceFilter();
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }

  showServiceColumns() {
    this.gridService.columnChooserModule.openColumnChooser(200, 50);
  }

  //..........................................GetServiceGroupDropdown...........................................................
  GetServiceGroupDropdown() {
    this.Msservice.GetServiceGroupDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceGroupList = data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  //..........................................DeleteService...........................................................
  DeleteService() {
    let params = new URLSearchParams();
    params.append("Id", this.saveServiceInfo.id);
    this.Msservice.DeleteService(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterservice.success('Service deleted successfully!');
      setTimeout(() => {
        this.toasterservice.clear();
      }, 8000);
      document.getElementById('closeServiceModal').click();
      this.getServiceFilter();
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }

  clearService() {
    this.saveServiceInfo = new saveServiceBO();
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  //get service type
  getServiceType(){
    let params = new URLSearchParams();
    params.append("ListCode", "ServiceTypeLid");
    this.Msservice.getServiceTypeDropdown(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServiceTypeList = data;
      this.TempServiceTypeList=data;
    }, (err: any) => {
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    });
  }
  ServiceTypeRestriction(SerGroupId) {
    console.log(this.ServiceGroupList,"ServiceGroupList");
    console.log(this.ServiceTypeList,"ServiceTypeList");
    let SerGrpName=this.ServiceGroupList.filter(a=>a.Key == SerGroupId)[0]?.Value;
    if(SerGrpName?.toUpperCase() != "PERSONAL ASSISTANCE")
        this.ServiceTypeList=this.ServiceTypeList.filter(a=>a.lovCode?.toUpperCase() != "OVERTIME");
    else
      this.ServiceTypeList=this.TempServiceTypeList;  
    console.log("after ServiceTYpe List",this.ServiceTypeList);
   }  
}
